'use client';

import React, { useState, useRef, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useApp } from '../../context/SafeAppContext';
import { getSectionByKey, getCmsSettings } from '../../services/cmsService';
import { getImageUrl } from '../../config/api';
import './Header.css';

const fallbackNavItems = [
  {
    id: 1, label: 'NEW ARRIVALS', url: '/shop?filter=newArrival', isActive: true,
    children: [
      { id: 101, label: 'Jameela', url: '/shop?collection=Jameela', isActive: true },
      { id: 102, label: 'Nur', url: '/shop?collection=Nur', isActive: true },
      { id: 103, label: 'Dilbaro Tissue', url: '/shop?collection=Dilbaro Tissue', isActive: true },
      { id: 104, label: 'Dilbaro Embroidered Velvets', url: '/shop?collection=Dilbaro Embroidered Velvets', isActive: true },
      { id: 105, label: 'Dilbaro', url: '/shop?collection=Dilbaro', isActive: true },
      { id: 106, label: 'Zoya', url: '/shop?collection=Zoya', isActive: true },
      { id: 107, label: 'Boond 3.0', url: '/shop?collection=Boond 3.0', isActive: true },
      { id: 108, label: 'Phillauri 2', url: '/shop?collection=Phillauri 2', isActive: true },
      { id: 109, label: 'Gulzaar', url: '/shop?collection=Gulzaar', isActive: true },
      { id: 110, label: 'Ishq', url: '/shop?collection=Ishq', isActive: true },
      { id: 111, label: 'Kapaas', url: '/shop?collection=Kapaas', isActive: true },
      { id: 112, label: 'Layla Florals', url: '/shop?collection=Layla Florals', isActive: true },
      { id: 113, label: 'Gulmohar Khari 25', url: '/shop?collection=Gulmohar Khari 25', isActive: true },
      { id: 114, label: 'Gulmohar Block Prints', url: '/shop?collection=Gulmohar Block Prints', isActive: true },
      { id: 115, label: 'Gulmohar', url: '/shop?collection=Gulmohar', isActive: true }
    ]
  },
  {
    id: 2, label: 'SHOP', url: '/shop', isActive: true,
    children: [
      { id: 201, label: 'Co-ord Sets', url: '/shop?category=Co-ord Sets', isActive: true },
      { id: 202, label: 'Lehengas', url: '/shop?category=Lehengas', isActive: true },
      { id: 203, label: 'Sarees', url: '/shop?category=Sarees', isActive: true },
      { id: 204, label: 'Anarkali Sets', url: '/shop?category=Anarkali Sets', isActive: true },
      { id: 205, label: 'Sharara Sets', url: '/shop?category=Sharara Sets', isActive: true },
      { id: 206, label: 'Kurta Sets', url: '/shop?category=Kurta Sets', isActive: true },
      { id: 207, label: 'Kaftan Sets', url: '/shop?category=Kaftan Sets', isActive: true },
      { id: 208, label: 'Dhoti Sets', url: '/shop?category=Dhoti Sets', isActive: true },
      { id: 209, label: 'Best Sellers', url: '/shop?filter=bestseller', isActive: true },
      { id: 210, label: 'Accessories', url: '/shop?category=Accessories', isActive: true },
      { id: 211, label: 'Home Edit', url: '/shop?category=Home Edit', isActive: true },
      { id: 212, label: 'Tote Bags', url: '/shop?category=Tote Bags', isActive: true },
      { id: 213, label: 'Potli Bags', url: '/shop?category=Potli Bags', isActive: true },
      { id: 214, label: 'Shawls', url: '/shop?category=Shawls', isActive: true },
      { id: 215, label: 'Caps', url: '/shop?category=Caps', isActive: true },
      { id: 216, label: 'Dupattas', url: '/shop?category=Dupattas', isActive: true }
    ]
  },
  { id: 3, label: 'OUR STORY', url: '/about', isActive: true, children: [] },
  { id: 4, label: 'READY TO SHIP', url: '/shop?filter=readyToShip', isActive: true, children: [] },
  { id: 5, label: 'LUXURY COLLECTION', url: '/shop?filter=luxury', isActive: true, children: [] },
  { id: 6, label: 'BESTSELLERS', url: '/shop?filter=bestseller', isActive: true, children: [] },
  { id: 7, label: 'ON SALE', url: '/shop?filter=onSale', isActive: true, children: [] },
  {
    id: 8, label: 'KIDS COLLECTION', url: '/category/KIDS OUTFITS', isActive: true,
    children: [
      { id: 801, label: 'Kids Lehengas', url: '/category/KIDS OUTFITS?type=Lehengas', isActive: true },
      { id: 802, label: 'Kids Anarkali', url: '/category/KIDS OUTFITS?type=Anarkali', isActive: true },
      { id: 803, label: 'Kids Kurta Sets', url: '/category/KIDS OUTFITS?type=Kurta Sets', isActive: true },
      { id: 804, label: 'Kids Co-ord Sets', url: '/category/KIDS OUTFITS?type=Co-ord Sets', isActive: true },
      { id: 805, label: 'Kids Party Wear', url: '/category/KIDS OUTFITS?type=Party Wear', isActive: true },
      { id: 806, label: 'Kids Casual Wear', url: '/category/KIDS OUTFITS?type=Casual Wear', isActive: true }
    ]
  }
];

const Header = () => {
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const [isScrolled, setIsScrolled] = useState(false);
  const [navItems, setNavItems] = useState(fallbackNavItems);
  const [logoUrl, setLogoUrl] = useState((process.env.PUBLIC_URL || '') + "/img/RANGAARA-navbar-logo.webp");
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };
    const handleResize = () => {
      setIsDesktop(window.innerWidth > 768);
    };
    handleResize();
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const [isCurrencyDropdownOpen, setIsCurrencyDropdownOpen] = useState(false);
  const [isUserDropdownOpen, setIsUserDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const navigate = useNavigate();

  // Page title logic for compact mobile header
  const getPageTitle = () => {
    const path = location.pathname;
    if (path === '/shop') return 'Shop';
    if (path === '/cart') return 'My Cart';
    if (path === '/checkout') return 'Checkout';
    if (path === '/wishlist') return 'Wishlist';
    if (path === '/profile') return 'My Account';
    if (path === '/orders') return 'My Orders';
    if (path.startsWith('/orders/')) return 'Order Details';
    if (path.startsWith('/product/')) return 'Product Details';
    if (path.startsWith('/category/')) return 'Collection';
    if (path === '/about') return 'Our Story';
    if (path === '/login') return 'Login';
    if (path === '/register') return 'Create Account';
    if (path === '/forgot-password') return 'Reset Password';
    if (path === '/returns') return 'Return Policy';
    if (path === '/refund') return 'Refund Policy';
    if (path === '/privacy') return 'Privacy Policy';
    if (path === '/disclaimer' || path === '/terms') return 'Terms & Conditions';
    return 'Rangaara';
  };

  const { user, currency, cart, wishlist, setCurrency, logout } = useApp();
  const isAdmin = user?.role === 'admin' || (typeof window !== 'undefined' && localStorage.getItem('isAdmin') === 'true');

  const currencies = [
    { code: 'INR', flag: '🇮🇳', name: 'INDIAN RUPEE (INR)' },
    { code: 'USD', flag: '🇺🇸', name: 'US DOLLAR (USD)' },
    { code: 'EUR', flag: '🇪🇺', name: 'EURO (EUR)' },
    { code: 'GBP', flag: '🇬🇧', name: 'BRITISH POUND (GBP)' },
    { code: 'CAD', flag: '🇨🇦', name: 'CANADIAN DOLLAR (CAD)' },
    { code: 'AUD', flag: '🇦🇺', name: 'AUSTRALIAN DOLLAR (AUD)' },
    { code: 'SGD', flag: '🇸🇬', name: 'SINGAPORE DOLLAR (SGD)' }
  ];

  const toggleCurrencyDropdown = () => setIsCurrencyDropdownOpen(!isCurrencyDropdownOpen);
  const toggleUserDropdown = () => setIsUserDropdownOpen(!isUserDropdownOpen);

  const selectCurrency = (currencyCode) => {
    setCurrency(currencyCode);
    setIsCurrencyDropdownOpen(false);
  };

  const handleLogout = () => {
    logout();
    setIsUserDropdownOpen(false);
    navigate('/');
  };

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/shop?search=${encodeURIComponent(searchQuery.trim())}`);
      setSearchQuery('');
      setIsMobileMenuOpen(false);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.currency-dropdown')) {
        setIsCurrencyDropdownOpen(false);
      }
      if (!event.target.closest('.user-dropdown')) {
        setIsUserDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  // Fetch live navigation & logo from Firestore
  useEffect(() => {
    const fetchNav = async () => {
      try {
        const section = await getSectionByKey('main_navigation');
        if (section?.content?.items?.length > 0) {
          setNavItems(section.content.items.filter(item => item.isActive !== false));
        }
        const settings = await getCmsSettings();
        if (settings?.logo) {
          setLogoUrl(getImageUrl(settings.logo));
        }
      } catch (err) {
        console.error('Failed to fetch navigation section from Firestore:', err);
      }
    };
    fetchNav();
  }, []);

  return (
    <header id="navbar-section" className={`${isScrolled ? 'scrolled' : ''} ${isHomePage ? 'home-header' : 'other-header'}`}>
      {/* ========== COMPACT MOBILE HEADER (inner pages only) ========== */}
      {!isHomePage && (
        <div className="compact-mobile-header">
          <button
            className="compact-back-btn"
            onClick={() => navigate(-1)}
            aria-label="Go back"
          >
            <i className="fa-solid fa-arrow-left"></i>
          </button>
          <h2 className="compact-page-title">{getPageTitle()}</h2>
          <div className="compact-header-actions">
            <button
              className="compact-search-btn"
              onClick={() => setIsMobileSearchOpen(true)}
              aria-label="Search"
            >
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
            <Link to="/cart" className="compact-cart-btn" aria-label="Shopping bag">
              <i className="fa-solid fa-bag-shopping"></i>
              {(cart?.items?.length || 0) > 0 && (
                <span className="compact-cart-badge">{cart.items.length}</span>
              )}
            </Link>
          </div>
        </div>
      )}

      {/* ========== MOBILE SEARCH OVERLAY ========== */}
      {isMobileSearchOpen && (
        <div className="mobile-search-overlay">
          <div className="mobile-search-bar">
            <button
              className="mobile-search-close"
              onClick={() => setIsMobileSearchOpen(false)}
              aria-label="Close search"
            >
              <i className="fa-solid fa-arrow-left"></i>
            </button>
            <form onSubmit={(e) => { handleSearch(e); setIsMobileSearchOpen(false); }} className="mobile-search-form">
              <input
                type="text"
                id="mobile-search-input"
                name="search"
                placeholder="Search for products..."
                aria-label="Search for products"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="mobile-search-input"
                autoFocus
              />
              <button type="submit" className="mobile-search-submit" aria-label="Submit search">
                <i className="fa-solid fa-magnifying-glass"></i>
              </button>
            </form>
          </div>
        </div>
      )}

      {/* ========== FULL HEADER (desktop always, mobile homepage only) ========== */}
      <div className={`top-header ${!isHomePage ? 'desktop-only-header' : ''}`}>
        <div className="header-left">
          <div className="hamburger-menu" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
            <i className={`fa-solid ${isMobileMenuOpen ? 'fa-xmark' : 'fa-bars'}`}></i>
          </div>
          
          <div className={`currency-dropdown mobile-currency-dropdown ${isCurrencyDropdownOpen ? 'active' : ''}`}>
            <span className="currency-selector" onClick={toggleCurrencyDropdown}>
              <span className="selected-flag">{currencies.find(c => c.code === currency)?.flag}</span> <i className="fa-solid fa-chevron-down"></i>
            </span>
            <div className={`currency-dropdown-menu ${isCurrencyDropdownOpen ? 'show' : ''}`}>
              {currencies.map((curr) => (
                <div key={curr.code} className="currency-option" onClick={() => selectCurrency(curr.code)}>
                  <span className="flag-icon">{curr.flag}</span>
                  <span className="currency-text">{curr.name}</span>
                </div>
              ))}
            </div>
          </div>

          <form onSubmit={handleSearch} className="search-form">
            <input
              type="text"
              id="desktop-search"
              name="search"
              placeholder="Search products..."
              aria-label="Search products"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="search-input"
            />
            <button type="submit" className="search-btn" aria-label="Search">
              <i className="fa-solid fa-magnifying-glass"></i>
            </button>
          </form>
        </div>

        <div className="header-center">
          <Link to="/" className="brand-logo" aria-label="Rangaara Home">
            <img
              src={logoUrl}
              alt="Rangaara"
              className="logo-image"
              width="101"
              height="100"
              fetchPriority="high"
              decoding="sync"
              onError={(e) => {
                e.target.style.display = 'none';
              }}
            />
          </Link>
        </div>

        <div className="header-right">
          <div className={`user-dropdown ${isUserDropdownOpen ? 'active' : ''}`}>
            <i className="fa-regular fa-user" onClick={toggleUserDropdown}></i>
            <div className={`user-dropdown-menu ${isUserDropdownOpen ? 'show' : ''}`}>
              {user ? (
                <>
                  <div className="user-info">
                    <span>Hello, {user.firstName || user.name || 'User'}</span>
                  </div>
                  <Link to="/profile" onClick={() => setIsUserDropdownOpen(false)}>Profile</Link>
                  <Link to="/orders" onClick={() => setIsUserDropdownOpen(false)}>Orders</Link>
                  {isAdmin && (
                    <Link to="/admin/dashboard" onClick={() => setIsUserDropdownOpen(false)} className="admin-link">
                      <i className="fa-solid fa-shield-halved"></i> Admin Panel
                    </Link>
                  )}
                  <button onClick={handleLogout}>Logout</button>
                </>
              ) : (
                <>
                  <Link to="/login" onClick={() => setIsUserDropdownOpen(false)}>Login</Link>
                  <Link to="/register" onClick={() => setIsUserDropdownOpen(false)}>Register</Link>
                </>
              )}
            </div>
          </div>

          <Link to="/wishlist" className="header-icon desktop-wishlist-icon" aria-label="Wishlist">
            <i className="fa-regular fa-heart"></i>
            {(wishlist?.length || 0) > 0 && <span className="badge">{wishlist.length}</span>}
          </Link>

          <div className={`currency-dropdown desktop-currency-dropdown ${isCurrencyDropdownOpen ? 'active' : ''}`}>
            <span className="currency-selector" onClick={toggleCurrencyDropdown}>
              <span className="selected-flag">{currencies.find(c => c.code === currency)?.flag}</span> <i className="fa-solid fa-chevron-down"></i>
            </span>
            <div className={`currency-dropdown-menu ${isCurrencyDropdownOpen ? 'show' : ''}`}>
              {currencies.map((curr) => (
                <div key={curr.code} className="currency-option" onClick={() => selectCurrency(curr.code)}>
                  <span className="flag-icon">{curr.flag}</span>
                  <span className="currency-text">{curr.name}</span>
                </div>
              ))}
            </div>
          </div>

          <Link to="/cart" className="header-icon" aria-label="Shopping bag">
            <i className="fa-solid fa-bag-shopping"></i>
            {(cart?.items?.length || 0) > 0 && <span className="badge">{cart.items.length}</span>}
          </Link>
        </div>
      </div>

      <nav className={`main-navigation ${isMobileMenuOpen ? 'mobile-open' : ''}`}>
        {navItems.map((item, idx) => {
          const hasChildren = Array.isArray(item.children) && item.children.length > 0;
          const activeChildren = hasChildren ? item.children.filter(ch => ch.isActive !== false) : [];

          if (activeChildren.length > 0) {
            return (
              <div key={item.id || idx} className="nav-item-with-dropdown">
                <Link
                  to={item.url || '#'}
                  onClick={(e) => {
                    if (!isDesktop) {
                      e.preventDefault();
                      setActiveDropdown(activeDropdown === item.id ? null : item.id);
                    }
                  }}
                >
                  {item.label} <i className="fa-solid fa-chevron-down"></i>
                </Link>
                {(activeDropdown === item.id || isDesktop) && (
                  <div className="mega-dropdown">
                    <div className="dropdown-column">
                      {activeChildren.map((child, cIdx) => (
                        <Link
                          key={child.id || cIdx}
                          to={child.url || '#'}
                          className="dropdown-item"
                          onClick={() => {
                            setIsMobileMenuOpen(false);
                            setActiveDropdown(null);
                          }}
                        >
                          {child.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            );
          }

          return (
            <Link
              key={item.id || idx}
              to={item.url || '#'}
              onClick={() => setIsMobileMenuOpen(false)}
            >
              {item.label}
            </Link>
          );
        })}

        <Link
          to="/wishlist"
          className="mobile-wishlist-nav-link"
          onClick={() => setIsMobileMenuOpen(false)}
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}
        >
          <span>WISHLIST</span>
          {(wishlist?.length || 0) > 0 && (
            <span className="wishlist-menu-badge" style={{
              backgroundColor: 'var(--color-primary-maroon)',
              color: 'white',
              borderRadius: '50%',
              width: '18px',
              height: '18px',
              fontSize: '10px',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center'
            }}>
              {wishlist.length}
            </span>
          )}
        </Link>
      </nav>

      {/* ========== DESKTOP BACK BAR (inner pages only, desktop only) ========== */}
      {!isHomePage && (
        <div className="desktop-back-bar">
          <div className="desktop-back-bar-inner">
            <button
              type="button"
              className="desktop-back-btn"
              onClick={() => navigate(-1)}
              aria-label="Go back"
            >
              <i className="fa-solid fa-arrow-left"></i>
              <span>Back</span>
            </button>
            <span className="desktop-back-page-title">{getPageTitle()}</span>
          </div>
        </div>
      )}
    </header>
  );
};

export default Header;